<template>
  <a-row class="p-2">
    <a-col :lg="3" :md="4" :sm="6" class="text-gray">
      <!--      <a-icon type="tag" />{{ " " }}-->
      <b class="ml-2">{{ field.name }}: </b>
    </a-col>
    <a-col :lg="21" :md="20" :sm="18" class="text-dark">
      <span>
        <span v-for="(i, index) in users" :key="i.id">
          <span v-if="index > 0">, </span> {{ i.fullname || i.username }}
        </span>
      </span>
    </a-col>
  </a-row>
</template>
<script>
import gql from "graphql-tag";

const userByIds = gql`
  query getUserByIds($ids: [ID!]!) {
    getUserByIds(ids: $ids) {
      id
      fullname
      username
      email
    }
  }
`;

export default {
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      users: []
    };
  },
  methods: {
    getUserByIds() {
      const ids = JSON.parse(this.field.value);
      if (ids && ids.length > 0) {
        this.$apollo
          .query({
            query: userByIds,
            variables: { ids }
          })
          .then(({ data }) => {
            if (data.getUserByIds?.length > 0) {
              this.users = data.getUserByIds;
            }
          })
          .catch(error => {
            console.log("Lỗi khi lấy dữ liệu", error);
          });
      }
    }
  },
  created() {
    this.getUserByIds();
  }
};
</script>
